import { render } from "./CustomerKpi.vue?vue&type=template&id=6e7d9c50&scoped=true"
import script from "./CustomerKpi.vue?vue&type=script&lang=js"
export * from "./CustomerKpi.vue?vue&type=script&lang=js"

import "./CustomerKpi.vue?vue&type=style&index=0&id=6e7d9c50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7d9c50"]])

export default __exports__